import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { EditButton, List, useDataGrid } from "@refinedev/mui";
import React, { useState } from "react";
import { RecycleButton } from "../../components/buttons/recycle";
import { RemoveButton } from "../../components/buttons/remove";
import UserStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/userStatus";

export const BadgeTypeList = () => {
  const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
    filters: {
      initial: [
        {
          field: "status",
          operator: "eq",
          value: 0,
        },
      ],
    },
    sorters: {
      initial: [
        {
          field: "updatedAt",
          order: "desc"
        }
      ]
    },
    pagination: {
      pageSize: 10
    }
  });

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 50,
        hideable: false
      },
      {
        field: "name",
        flex: 1,
        headerName: "Name",
        minWidth: 150,
        hideable: false
      },
      {
        field: "description",
        flex: 1,
        headerName: "Description",
        minWidth: 400,
        hideable: false
      },
      {
        field: "status",
        headerName: "Status",
        minWidth: 150,
        hideable: false,
        renderCell: function render({ row }) {
            return UserStatus.fromValue(row.status)?.name;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        sortable: false,
        hideable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              {row.status ? (
                <RecycleButton hideText recordItemId={row.id} />
              ) : (
                <RemoveButton hideText recordItemId={row.id} />
              )}
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    []
  );
  // search parts
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(0);
  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (name) {
      searchArr.push({
        field: "name[$ilike]",
        value: `%${name}%`,
        operator: "eq",
      });
    }
    if (description) {
      searchArr.push({
        field: "description[$ilike]",
        value: `%${description}%`,
        operator: "eq",
      });
    }
    if (status || status === 0) {
      searchArr.push({
        field: "status",
        value: `${status}`,
        operator: "eq",
      });
    }
    setFilters(searchArr as any);
  };

  const clearFun = () => {
    setCurrent(1);
    setPageSize(10);
    setName("");
    setDescription("");
    setStatus(0);
    setFilters([
      {
        field: "status",
        value: 0,
        operator: "eq",
      },
    ]);
  };
  return (
    <List>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="Name"
                variant="standard"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ width: "27%" }}
              />
              <TextField
                id="standard-basic"
                label="Description"
                variant="standard"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                style={{ width: "27%" }}
              />
              <FormControl style={{ width: "27%" }}>
                <InputLabel id="action">Status : </InputLabel>
                <Select
                  labelId="action"
                  value={status as any}
                  label="Status"
                  variant="standard"
                  onChange={(event: SelectChangeEvent) => {
                    setStatus(event.target.value as any);
                  }}
                >
                  {Object.values(UserStatus)[0].map((item: any) => {
                    return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
              <div style={{ width: "10%", paddingBottom: "7px" }}>
                <ClearOutlinedIcon onClick={clearFun} />
                <SearchIcon onClick={handleFilter} />
              </div>
            </div>
          </div>
        }
      />
      <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
    </List>
  );
};
